import Button from '@/components/button';
import { downloadProxyConnectorZip } from '@/lib/services/connector.service';

import { useQuery } from 'react-query';
import { QueryKey } from '@/lib/query-client';

interface Props {
  id: string;
  name: string;
}

const ButtonProxyFileDownload = ({ id, name }: Props) => {
  const { refetch, isFetching } = useQuery(
    [QueryKey.ProxyConnectorDownload, id],
    async () => {
      await downloadProxyConnectorZip(id, name);
    },
    { enabled: false }
  );

  const handleDownload = () => {
    refetch();
  };

  return (
    <Button
      label="Download"
      icon="download"
      onClick={handleDownload}
      size="small"
      loading={isFetching}
    />
  );
};

export default ButtonProxyFileDownload;
